import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["src"]

import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay, Pagination } from 'swiper'
import { useThemeColor } from '@/utils/theme'
import { Record } from '@/api/Models/HomeAdvertiseList'
import { useRouter } from 'vue-router'
import { handleExternalUrl } from '@/utils/navigation'


export default /*@__PURE__*/_defineComponent({
  __name: 'Advertise',
  props: {
    data: {},
    modelValue: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v277509f2": (_unref(themeColor))
}))


const commits = __emit

const closeHandle = () => {
  commits('update:modelValue', false)
}

const router = useRouter()
const skipHandle = (item: Record) => {
  commits('update:modelValue', false)
  switch (
    item.appJumpStatus // 链接
  ) {
    case 1:
      handleExternalUrl({ jumpUrl: item.appJumpUrl })
      break
    case 2:
      router.push({
        // 课程
        name: 'courseDetail',
        query: {
          id: item.appJumpUrl,
          courseId: '',
          endingType: 0,
          channel: 1,
          courseType: item.appJumpCourseType === 0 ? 'course' : 'courseWare'
        }
      })
      break
    case 3: // 资讯
      router.push('/broadcastDetail/' + item.appJumpUrl)
      break
    case 4: // 培训
      router.push('/trainingDetail?id=' + item.appJumpUrl)
      break
    case 5: // 考试
      router.push('/examInfo?examId=' + item.appJumpUrl)
      break
    case 6: // 调查
      router.push('/surveyInfo?investigationId=' + item.appJumpUrl)
      break
    default:
      break
  }
}

const modules = [Autoplay, Pagination]
const themeColor = useThemeColor()
const pagination = {
  clickable: true,
  renderBullet(index: number, className: string) {
    return '<span class="' + className + '"></span>'
  }
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "advertise_container",
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
    onTouchmove: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop","prevent"]))
  }, [
    _createVNode(_unref(Swiper), {
      modules: modules,
      centeredSlides: true,
      loop: "",
      autoplay: "",
      class: "banner_wrapper",
      pagination: pagination
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.slice(0, 3), (item, index) => {
          return (_openBlock(), _createBlock(_unref(SwiperSlide), {
            key: index,
            onClick: ($event: any) => (skipHandle(item))
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: item.appImgUrl,
                class: "banner_img"
              }, null, 8, _hoisted_1)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: "close_icon",
      onClick: closeHandle
    }, [...(_cache[2] || (_cache[2] = [
      _createElementVNode("i", { class: "iconfont icon-icon_wode_wodepeixun_kejianyulan_guanbi" }, null, -1)
    ]))])
  ], 544)), [
    [_vShow, __props.modelValue]
  ])
}
}

})